<template>
  <div class="section">
    <div class="header" @click="onHeaderClick()">
      <span class="header_title">{{ title }}</span>
      <img v-if="isCollapsed" src="../../../assets/img/right_arrow_gray.png">
      <img v-if="!isCollapsed" src="../../../assets/img/down_arrow_gray.png">
    </div>

    <ul class="pg_list" v-if="!isCollapsed">
      <li v-for="(item, index) in pg_list" class="pg_item" @click="onItemClick(item, index)">
        <img :src="require(`../../../assets/img/${item.productCode}.png`)" style="width: 60px;height: 20px;">
        <span class="item_title" style="flex-grow: 1;margin-left: 12px;">{{ item.productName }}</span>
        <img src="../../../assets/img/right_arrow_gray.png">
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'PaymentMethodGroup',
  components: {
  },
  props: {
    title: {
      type: String,
    },
    pg_list: {
      type: Array
    }
  },
  emits: ['onItemClick'],
  data() {
    return {
      isCollapsed: true
    }
  },
  computed: {
  },
  methods: {
    onHeaderClick: function() {
      this.isCollapsed = !this.isCollapsed;
    },
    onItemClick: function(item, index) {
      this.$emit('onItemClick', item, index);
    },
  }
}
</script>

<style scoped>
.section {position:relative;display:flex;flex-direction:column;align-items:stretch;padding:26px;background-color: #F9F9F9;border-radius: 18px;}
.section .header {display:flex;flex-direction: row;align-items: center;justify-content:space-between;margin: 0px 0px 00px 0px;}
.header_title {font-size: 16px;font-weight: 500;}
.pg_list {margin-top: 10px;}
.pg_item {display:flex;flex-direction: row;align-items: center;justify-content: stretch;padding: 20px 0px;}
</style>